import styled from 'styled-components';
import Row from 'components/grid/Row';

const PageWrapper = styled(Row)`
  flex-direction: column;
`;

const FileNameInfo = styled.p` 
  ${({ theme }) => theme.typograph.paragraphMedium}
  margin-bottom: 32px;
`;

export {
  FileNameInfo,
  PageWrapper,
};
